module.exports = __webpack_public_path__ + "static/media/sculpture-1.5b506437.jpg";